import { useState,useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Project from './project';
import About from './About';
import { floorListData } from '../floorListData.js'
import "./page.css";
import ig from "../Assets/ig.png";
import logo from "../Assets/64.png";
import cloud from '../Assets/cloud.png';
import Tower from '../Assets/Tower.png';
import Base from "../Assets/Base.png";
import Foundation from "../Assets/Foundation.png"
import Fire from '../Assets/Fire.png';

export default function Home() {
  const [portfolio, setPortfolio] = useState(false);
  const [showPort] = useState('flex');
  const [viewProject, setViewProject] = useState(false);
  const [viewAbout, setViewAbout] = useState(false);
  const [twFloor, setTowerFloor] = useState(0);
  const [leftImgX, setlImgX] = useState('-101%');
  const [hoverIndex, setHoverIndex] = useState(null);
  // const [hoverFloor, setHoverFloor] = useState(0);
  const [floorTitle, setTitle] = useState({title:'Select a floor to begin'});
  const [explodeView, setExplodeView] = useState(false);
  let fldMap = floorListData.map(item => item.number);
  const fldRev = [...fldMap].reverse();
    const [projectData, setProjectData] = useState({
    title: '',
    description: ''
  });
const generateBaseTransforms = (count, start = 0, step = 71) => {
  return Array.from({ length: count }, (_, i) => `${start - i * step}%`);
};

const baseTransforms = generateBaseTransforms(floorListData.length + 1);
    // offset by -29% for new entry
    
useEffect(() => {
  const baseEl = document.querySelector('.baseSection');
  if (!baseEl) return;
  const isMobile = window.innerWidth <= 768;
  const maxScroll = (isMobile ? 300 : 500);
  let isLocked = false;
  const handleScroll = () => {
    if (isLocked) return;

    if (baseEl.scrollTop > maxScroll) {
      isLocked = true;

      baseEl.scrollTo({
        top: maxScroll,
        behavior: 'smooth'
      });

      baseEl.removeEventListener('scroll', handleScroll);

      setTimeout(() => {
        baseEl.addEventListener('scroll', handleScroll);
        isLocked = false;
      }, 10); // wait 300ms before re-enabling the listener
    }
  };
  baseEl.addEventListener('scroll', handleScroll);
  return () => {
    if (baseEl) {
      baseEl.removeEventListener('scroll', handleScroll);
    }
  };
}, []);

function selectFloor(index){
    if(index !== undefined) {
          setTitle(floorListData[index-1]);
          setProjectData(floorListData[index-1]);
    }
  }
  function towerFloor(index){
    setTowerFloor(index);
  }
function enterPortfolio() {
  const newPortfolio = !portfolio; 
  setPortfolio(newPortfolio);   
  setX(newPortfolio);
  setTitle({title:null});
}

function setX(toggle) {
  if (toggle) {
    setlImgX('0%'); 
  } else {
    setlImgX('-101%');
  }
}
// function project(){
//   setViewProject('none');
// }
const openAbout = () => {
  setViewAbout(prev => !prev);
}

const toggleExplode = () => {
  setExplodeView(prev => !prev);
  setViewProject(prev => !prev);
};

  return (
    <>
      <Helmet>
        <title>64 Floors – Creative Art Project</title>
        <link rel="icon" type="image/png" sizes="32x32" href="../Assets/64.png" />
        <meta
          name="description"
          content="64 Floors is an artistic journey through 64 unique creative spaces, each representing a different art style and mood."
        />
        <meta name="keywords" content="64 Floors, art project, creative series, Instagram art" />
        {/* Open Graph (for sharing) */}
        <meta property="og:title" content="64 Floors - Creative Art Project" />
        <meta property="og:description" content="Explore 64 unique floors of creativity." />
        <meta property="og:image" content="https://64floors.com/static/media/Base.37372380a2b4afafec1d.png" />
        <meta property="og:url" content="https://64floors.com" />
      </Helmet>
    <div className="page">
      <div className={"header"}>{portfolio ?  <div className="headerText" onClick={enterPortfolio}>LOST TOWER INC</div> : <div className="headerText">SIXTY FOUR  FLOORS</div>}<div className="rightHeader" onClick={openAbout}><p className="aboutText">What is 64Floors?</p> <img className="icon" src={logo} alt="site logo"></img></div></div>
        <div className={"mainSection"} onMouseLeave={() => setHoverIndex(null)}>
          {viewProject ? <Project info={projectData} close={toggleExplode}/> : <></>}
          {viewAbout ? <About close={openAbout}/> : <></>}
            <div className={"overlayContainer"}>
              <div className={"cloudContainer"}><img className="cloudImg" src={cloud} alt='background Cloud img'></img> </div>
            {floorTitle.title !== null ? <div className={"infoCard"}>
              <div className={"FLtitle"}>{floorTitle.title}</div>
              <i className={"releaseDate"}>{floorTitle.release}</i>
              {floorTitle.title == 'Select a floor to begin' ? <></> : <div className={"FLlink"} onClick={toggleExplode}>VIEW PROJECT</div>}
            </div> : <></>}
            </div>
            <div className={"baseSection"}>
            {baseTransforms.map((offset, index) => {
              let translateY = offset;
              let img = Base;
              let portImg = Tower;
              let explodeOffset = 0;
              if (explodeView && hoverIndex !== null) {
                if (index < hoverIndex) {
                  explodeOffset = '-120vh'; // push blocks above offscreen
                } else if (index > hoverIndex) {
                  explodeOffset = '120vh'; // push blocks below offscreen
                }
              }

              
              if(index === baseTransforms.length-1){
                img = Foundation;
              }
              if(fldRev[index] === twFloor) {
                portImg = Fire;
              }
              let isHovered = false;
              if (hoverIndex !== null && index <= hoverIndex) {
                 isHovered = index === hoverIndex;
                 if(hoverIndex === index){
                 }
                const diff = hoverIndex - index;
                let lift = 30 - diff * 3;
                if(hoverIndex === baseTransforms.length-1){
                  lift = 0;
                  offset = 0;
                }
                if(viewProject === 'none') {
                  offset = 1000;
                }
                translateY = `calc(${offset} - ${lift}%)`;
                
            }
      return (
        <div className={"base"} key={index}>
          <div className={"baseSelection"}>
            <div className={"selection"}
                 style={{
                    transform: `translateY(${translateY})`,
                    zIndex: baseTransforms.length - index + 1,
                    transition: 'transform 0.3s ease',
                  }}
                  onMouseEnter={() => {setHoverIndex(index)}}
                  // onMouseLeave={() => setHoverIndex(null)}
                  onClick={() => selectFloor(fldRev[index])}>
                <div className={`${"rotate"} ${isHovered ? "fadeIn" : "fadeOut"}`}>
                  {isHovered && floorListData[index] !== undefined ? <>Floor {`${fldRev[index]}`}</> : <></>}
                </div>
            </div>
          </div>
            <img
              key={index + 'port'}
              className={"portImg"}
              src={portImg}
              alt={`PORTFOLIO IMG`}
              onClick={() => {towerFloor(fldRev[index])}}
              style={{
                zIndex: baseTransforms.length - index + 1,
                transform: `translateY(${translateY}) translateX(${leftImgX})`,
                transition: `transform 0.8s ease ${fldRev[index] * 175}ms` , 
                display: `${showPort}`,
              }}/>
            <img
              key={index}
              className={"baseImg"}
              src={img}
              alt={`Cuboid Block of a single floor of a building a link to Floor ${index}.`}
              style={{
                transform: `translateY(${explodeOffset || translateY})`,
                zIndex: baseTransforms.length - index,
                transition: 'transform 0.5s ease',
              }}/>
        </div>
      );
    })}
            </div>
        </div>
        <div className={"footer"}>
          <a className="igIcon"  href="https://www.instagram.com/64floors/" target="_blank" rel="noopener noreferrer">
          <img className="igIcon" src={ig} alt="icon for linking instagram" />
          </a>
          <div>64 Floors Project</div>
          </div>
    </div>
    </>
  );
}
